<template>
  <my-dialog ref="editForm" title="出库单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">
    <div class="main_bg">
      <div class="item_info border_Warningcolor">
        <el-descriptions class="margin-top" title="基本信息" :column="3" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              出库单号
            </template>
            {{ this.editForm.outputStoreNo }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              出库时间
            </template>
            {{ this.editForm.outputDate }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              所属门店
            </template>
            {{ this.editForm.belongStoreName }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              顾客姓名
            </template>
            {{ transformEmpty(customerInfo.name) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              性别
            </template>
            {{ transformGender(customerInfo.gender) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              年龄
            </template>
            {{ transformEmpty(customerInfo.age) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              顾客电话
            </template>
            {{ transformEmpty(customerInfo.phone) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              下单日期
            </template>
            {{ transformEmpty(editForm.orderDate) }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              取镜日期
            </template>
            {{ transformEmpty(editForm.getOrderDate) }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              验光师
            </template>
            {{ transformEmpty(editForm.yanGuangShi) }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              加工类型
            </template>
            {{ transformEmpty(editForm.machinTypeStr) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              出库状态
            </template>
            {{ editForm.outputStateStr }}
          </el-descriptions-item>

          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              镜架信息
            </template>
            {{ transformEmpty(editForm.jjInformation) }}
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              备注
            </template>
            {{ transformEmpty(editForm.remark) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Green">
        <div class="item_title">
          <div class="title">商品信息</div>
        </div>
        <el-table :data="goodsTableData" style="width: 100%" border
          :header-cell-style="{ textAlign: 'center', borderColor: '#333' }"
          :cell-style="{ textAlign: 'center', borderColor: '#333' }">
          <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
          <el-table-column prop="type" label="商品品牌" width="120"></el-table-column>
          <el-table-column prop="name" label="商品名称"> </el-table-column>
          <el-table-column prop="qiuJing" label="球镜" width="80">
          </el-table-column>
          <el-table-column prop="zhuJing" label="柱镜" width="80">
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="80">
          </el-table-column>
          <el-table-column v-if="isShowMoney" prop="price" label="单价" width="100">
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="155">
          </el-table-column>
          <el-table-column v-if="isShowMoney" prop="money" label="金额" width="100">
          </el-table-column>
          <el-table-column prop="remark" label="ADD"> </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
    </div>
  </my-dialog>
</template>
<script>
import { GetOutputStoreDetail } from "@/api/receiptApi.js";

export default {
  props: [],
  data() {
    return {
      showDialog: false,
      saveloading: false,
      editForm: {},
      goodsKeyIds: [],
      supplyList: [],
      customerInfo: {},
      goodsTableData: [],
      goodsIndex: 1,
      isShowMoney: false,
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() { },
  methods: {
    // 显示
    showDetailDialog(keyId) {
      this.editForm.keyId = keyId;
      this.showDialog = true;
      this.GetOutputStoreDetail();

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
        this.isShowMoney = true;
      } else {
        this.isShowMoney = false;
      }
    },
    // 获取入库单详情
    GetOutputStoreDetail() {
      this.saveloading = true;
      const params = {
        keyId: this.editForm.keyId,
      };
      GetOutputStoreDetail(params)
        .then((res) => {
          this.saveloading = false;
          if (res.code == 1) {
            this.editForm = res.data;
            this.customerInfo = res.data.customerInfo;
            if (res.data.dtls != null && res.data.dtls.length > 0) {
              let rowNumber = 1;
              res.data.dtls.forEach((item) => {
                var info = {};
                info.rowNumber = rowNumber++;
                info.name = item.goodsInfo.name;
                info.type = item.goodsInfo.type;
                info.unit = item.goodsInfo.unit;
                info.qiuJing = item.goodsInfo.qiuJing;
                info.zhuJing = item.goodsInfo.zhuJing;
                info.goodsKeyId = item.goodsInfo.keyId;
                info.remark = item.remark;
                info.quantity = item.quantity;
                info.money = item.money;
                info.price = item.price;
                this.goodsTableData.push(info);
              });
            }
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.saveloading = false;
          this.$message.error("生成失败，请稍后再试！");
        });
    },
    // 关闭
    closeDialog() {
      this.$data.editForm = this.$options.data.call(this).editForm;
      this.goodsKeyIds = [];
      this.goodsIndex = 1;
      this.goodsTableData = [];
      this.showDialog = false;
    },
    // 性别
    transformGender(gender) {
      return gender == 1 ? "男" : gender == 0 ? "女" : "";
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
  },
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
  }
}
</style>